import { handleActions } from "redux-actions";
import build from "redux-object";
import get from "lodash/get";
import { createAction } from "redux-actions";
import reduceReducers from "reduce-reducers";

import {
  BACKEND_PROCESSING_ONGOING,
  FETCH_IDS_START,
  FETCH_IDS_SUCCESS,
  FETCH_SUCCESS,
  FETCH_FAILED,
  FETCH_START,
  UPDATE_RESOURCE_FIELDS,
  DELETE_RECORD_SUCCESS,
  PROMOTE_IN_PROGRESS_INVOICES,
  SET_PAGE,
  CLEAR_INVOICES
} from "../actions";
import { INVOICE_SERVICES } from "../components/Invoices/constants";

export const fetchStart = createAction(FETCH_START);
export const fetched = createAction(FETCH_SUCCESS);
export const notFetched = createAction(FETCH_FAILED);

const initialState = {
  list: {},
  paging: { page: 0, hasMore: true, isNewDataSet: false },
  errors: [],
  resourceType: ""
};

const deleteReducer = handleActions(
  {
    [DELETE_RECORD_SUCCESS]: (resourcesState, action) => {
      const resourceType = action.resource;
      if (resourceType) {
        const { list, ...rest } = resourcesState;
        const { [resourceType]: resource, ...restOfList } = list;
        if (resource) {
          const { [action.recordSlug]: removedValue, ...restOfTheResource } = resource;
          const newState = { ...rest, list: { ...restOfList, [resourceType]: { ...restOfTheResource } } };
          return newState;
        } else {
          return resourcesState;
        }
      } else {
        return resourcesState;
      }
    }
  },
  initialState
);

const backendProcessingReducer = handleActions(
  {
    [BACKEND_PROCESSING_ONGOING]: (resourcesState, { isBackendProcessingOngoing }) => {
      return {
        ...resourcesState,
        isBackendProcessingOngoing: isBackendProcessingOngoing
      };
    }
  },
  initialState
);

const listReducer = handleActions(
  {
    [FETCH_IDS_START]: (resourcesState, action) => {
      return {
        ...resourcesState,
        isFetchingInProgress: action.isFetchingInProgress
      };
    },

    [FETCH_IDS_SUCCESS]: (resourcesState, { payload }) => {
      return {
        ...resourcesState,
        listOfAllResourceIdOnly: Object.values(payload[resourcesState.resourceType]),
        isFetchingInProgress: false
      };
    },

    [FETCH_SUCCESS]: (resourcesState, { payload, totalResourceNumber }) => {
      const { list: state } = resourcesState;
      const { isNewDataSet } = resourcesState.paging;

      if (!isNewDataSet) {
        const appendedState = Object.entries(payload).reduce((result, [resourceType, records]) => {
          result[resourceType] = { ...state[resourceType], ...records };
          return result;
        }, {});
        return { ...resourcesState, list: { ...state, ...appendedState }, totalResourceNumber: totalResourceNumber };
      }
      return { ...resourcesState, list: { ...payload }, totalResourceNumber: totalResourceNumber };
    },

    [FETCH_FAILED]: (resourcesState, action) => ({ ...resourcesState, list: {} }),
    [UPDATE_RESOURCE_FIELDS]: (resourcesState, { id, payload }) => {
      const { list: state, resourceType } = resourcesState;

      const record = state[resourceType][id];
      const updatedRecord = { ...record, attributes: { ...record.attributes, ...payload } };

      return { ...resourcesState, list: { ...state, [resourceType]: { ...state[resourceType], [id]: updatedRecord } } };
    },
    [PROMOTE_IN_PROGRESS_INVOICES]: (resourcesState, action) => {
      return { ...resourcesState, list: {} };
    }
  },
  initialState
);

const pagingReducer = handleActions(
  {
    [FETCH_START]: (resourcesState, action) => {
      const { paging: state } = resourcesState;

      const { page } = action.payload;
      const isNewDataSet = state.page !== 0 && page === 1;

      return { ...resourcesState, paging: { ...state, isNewDataSet, page } };
    },
    [FETCH_SUCCESS]: (resourcesState, action) => {
      const { paging: state, resourceType } = resourcesState;
      const { page } = action.payload;

      const data = get(action, `payload.${resourceType}`, {});
      const underPageSize = Object.keys(data).length < 15;
      let hasMore;

      if (action.status === "inProgress" && action.service === INVOICE_SERVICES.INTERNAL_INVOICES) {
        hasMore = page * 15 < get(action, "totalResourceNumber");
      } else {
        const { first, last, next } = get(action, `payload.meta.${resourceType}.links`, {});

        hasMore = first !== undefined && last !== undefined && next !== undefined && !underPageSize;
      }

      return { ...resourcesState, paging: { ...state, page, hasMore, isNewDataSet: false } };
    },

    [FETCH_FAILED]: (resourcesState, action) => ({
      ...resourcesState,
      paging: { page: 0, hasMore: true, isNewDataSet: false }
    }),

    [SET_PAGE]: (resourcesState, action) => ({
      ...resourcesState,
      paging: { page: action.page, hasMore: action.hasMore, isNewDataSet: false }
    }),
    [CLEAR_INVOICES]: (resourcesState, action) => {
      return {
        ...resourcesState,
        list: { meta: {}, internalInvoices: {}, invoices: {} },
        paging: { page: 0, hasMore: true, isNewDataSet: true }
      };
    },
    "@@router/LOCATION_CHANGE": (resourcesState, action) => {
      return {
        ...resourcesState,
        list: {},
        paging: { page: 0, hasMore: true, isNewDataSet: true }
      };
    }
  },
  initialState
);

const errorReducer = handleActions(
  {
    [FETCH_SUCCESS]: (resourcesState, action) => ({ ...resourcesState, errors: [] }),

    [FETCH_FAILED]: (resourcesState, { payload: { errors = [] } }) => ({ ...resourcesState, errors })
  },
  initialState
);

const typeReducer = handleActions(
  {
    SET_RESOURCE_TYPE: (resourcesState, { resourceType }) => ({ ...resourcesState, resourceType })
  },
  initialState
);

export const getResourceById = (state, id) => {
  const resourceType = getResourceType(state);
  return build(state.resources.list, resourceType, id, {
    eager: false,
    ignoreLinks: true
  });
};

export const getResourceList = (state, type) => {
  const resourceType = type || getResourceType(state);

  return build(state.resources.list, resourceType, null, {
    eager: false,
    ignoreLinks: true
  });
};

export const getResourceType = state => state.resources.resourceType;

export const setResouceType = type => async dispatch => {
  dispatch({ type: "SET_RESOURCE_TYPE", resourceType: type });
};

export const getPaging = state => state.resources.paging;

export default reduceReducers(
  initialState,
  typeReducer,
  listReducer,
  pagingReducer,
  errorReducer,
  deleteReducer,
  backendProcessingReducer
);
